export enum EmployeeRole {
    Admin = 'ADMIN',
    Booker = 'BOOKER',
    Passenger = 'PASSENGER',
}

export const EMAIL_VALIDATION_REGEX = /^.+@.+\..{2,}$/;

export const EMPLOYEES_PAGE_SIZE = 100;
